import { ReportProfileAlertResourceBaseModel } from '../../../profile/report-profile-alert-resource-base-model';
import { ZimbraMailingReportProfileFilterRule } from '../../../zimbra/mailing/profile/zimbra-mailing-report-profile-filter-rule';

export class ZimbraMailingReportProfileAlertFilterRuleModel extends ReportProfileAlertResourceBaseModel {
  filterRule: ZimbraMailingReportProfileFilterRule;
}
